import React, { useState } from "react";
import { Table } from "antd";
import { toast } from "react-toastify";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import api from "../../../../api";

const FolderDataTable = ({ data, loading }) => {
  const [downloadingMap, setDownloadingMap] = useState({});

  const handleDownload = async (record) => {
    setDownloadingMap((prev) => ({ ...prev, [record.folder_name]: true })); // Mark the record as downloading
    const formData = new FormData();
    formData.append("folder_name", record.folder_name);

    try {
      const response = await api.post("/download-payroll-folder", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        responseType: "blob",
      });

      const blob = new Blob([response.data], { type: "application/zip" });
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = `${record.folder_name || "payroll_folder"}.zip`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(downloadLink.href);
    } catch (error) {
      console.error(error);
      toast.error("Failed to Download. Please try again.");
    } finally {
      setDownloadingMap((prev) => ({ ...prev, [record.folder_name]: false }));
    }
  };

  const columns = [
    {
      title: "File Count",
      dataIndex: "file_count",
    },
    {
      title: "Folder Name",
      dataIndex: "folder_name",
    },
    {
      title: "Action",
      render: (text, record) => (
        <div className="d-flex align-items-center">
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id={`tooltip-${record.folder_name}`}>
                {downloadingMap[record.folder_name]
                  ? "Downloading..."
                  : "Download"}
              </Tooltip>
            }
          >
            <button
              className="btn btn-icon btn-primary btn-sm"
              onClick={() => handleDownload(record)}
              disabled={downloadingMap[record.folder_name]} // Disable only the button for the downloading record
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                backgroundColor: downloadingMap[record.folder_name]
                  ? "#95a5a6"
                  : "#3498db",
                color: "#fff",
                fontSize: "18px",
                border: "none",
                cursor: downloadingMap[record.folder_name]
                  ? "not-allowed"
                  : "pointer",
              }}
            >
              {downloadingMap[record.folder_name] ? (
                <i className="fa fa-spinner fa-spin" />
              ) : (
                <i className="fa fa-download" />
              )}
            </button>
          </OverlayTrigger>
        </div>
      ),
    },
  ];

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="table-responsive">
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            rowKey="folder_name" // Use folder_name as the unique key for rows
            pagination={{ pageSize: 10 }}
          />
        </div>
      </div>
    </div>
  );
};

export default FolderDataTable;
